export default {"src":"/_next/static/media/lt.81df61ea.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};